<template>
    <div class="lp-blog-post-details">
        <section class="row lp-hero fg-imaga lp-hero--alt-hero lp-hero--blog-hero" style="background-image: url('');
    		background-position: 50% 50%;">

            <div class="lp-hero__content col-12 col-xl">
                <a :href="blogUrl" class="link link-icon link-icon-w link-icon--left lp-hero-title-link">
                    Back to Blog List
                    <i class="fas fa-chevron-circle-left fa-stack "></i>
                </a>

                <h3 class="lp-hero-title-label">{{post.Tags.join(" ")}}</h3>
                <h1 lp-hero-title for-hero>{{post.Title}}</h1>
                <span class="lp-hero-date text-primary-600 mb-5">{{post.PublicationDate}}</span>

                <div class="mt-5 share-section">
                    <p>Share:</p>
                    <div class="d-flex">
                        <div class="mt-4 d-flex align-items-center justify-content-center">
                            <a :href="facebookShareUrl"
                               target="_blank"
                               class="fa-stack fa-2x ">
                                <i class="fas fa-circle fa-stack-2x text-tertiary circle-icon"></i>
                                <i class="fab fa-facebook-f fa-stack-1x fa-inverse icon-size text-white"></i>
                            </a>
                        </div>
                        <div class="mt-4 d-flex align-items-center justify-content-center">
                            <a :href="twitterShareUrl"
                               class="fa-stack fa-2x "
                               target="_blank">
                                <i class="fas fa-circle fa-stack-2x text-tertiary circle-icon"></i>
                                <i class="fab fa-twitter fa-stack-1x fa-inverse icon-size text-white"></i>
                            </a>
                        </div>
                        <div class="mt-4 d-flex align-items-center justify-content-center">
                            <a :href="linkedinShareUrl"
                               class="fa-stack fa-2x "
                               target="_blank">
                                <i class="fas fa-circle fa-stack-2x text-tertiary circle-icon"></i>
                                <i class="fab fa-linkedin-in fa-stack-1x fa-inverse icon-size text-white"></i>
                            </a>
                        </div>
                        <div class="mt-4 d-flex align-items-center justify-content-center">
                            <a :href="shareUrl"
                               class="fa-stack fa-2x ">
                                <i class="fas fa-circle fa-stack-2x text-tertiary circle-icon"></i>
                                <i class="far fa-share-alt fa-stack-1x fa-inverse icon-size text-white"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="post.ImageUrl != ''" class="lp-hero__fg-image col-12 mt-5 col-xl mt-xl-0">
                <img class="w-100" :src="post.ImageUrl" :alt="post.ImageAlt">
            </div>
        </section>

        <section class="row">
            <div class="lp-blog-post-details__main col-12 mt-5 col-xl-6 mt-xl-0 offset-xl-5">
                <div v-html="decodedContent"
                     class="lp-blog-post-details__content">
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue';

    import { decodeHtml } from '../helpers/html';

    export default {
        name: 'BlogPostDetails',
        props: {
            blogUrl: {
                type: String,
            },
            classes: {
                type: String,
            },
            content: {
                type: String,
            },
            featuredPosts: {
                type: Array,
            },
            post: {
                type: Object,
                required: true,
            }
        },
        setup(props) {
            console.log("BLOG PROPS: ", props)
            // SEARCH
            const searchInput = ref('');
            const searchHandler = () => {
                if (searchInput.value && searchInput.value !== '') {
                    console.log(searchInput.value);
                    console.log(props.blogUrl)
                    window.location.href = `${props.blogUrl}?search=${searchInput.value}`;
                }
            };
            const facebookShareUrl = ref('')
            const twitterShareUrl = ref('')
            const linkedinShareUrl = ref('')
            const shareUrl = ref('')

            /*
                const facebookShareUrl = ref('#')
                const shareUrl = ref('#')
            */

            const createTwitterUrl = () => {
                const url = new URL('https://twitter.com/intent/tweet')

                const tweetUrl = props.post.Url

                //const tweetText = "This is a test message";
                //const hashtags = [""]

                url.searchParams.append("url", tweetUrl)
                //url.searchParams.append("text", tweetText)
                //url.searchParams.append("hashtags", hashtags.join(","))

                twitterShareUrl.value = url.toString();
            }

            const createLinkedinUrl = () => {
                const url = new URL('https://www.linkedin.com/sharing/share-offsite/')

                const postUrl = props.post.Url;

                url.searchParams.append("url", postUrl);
                linkedinShareUrl.value = url.toString();
            }

            const createFacebookUrl = () => {
                const url = new URL('https://www.facebook.com/sharer/sharer.php')
                const postUrl = props.post.Url;

                url.searchParams.append("u", postUrl);
                facebookShareUrl.value = url.toString();
            }

            const createShareUrl = () => {
                shareUrl.value = "#"
            }

            const removeListTitle = () => {
                const title = document.querySelector(".blog-title");

                if (title) {
                    title.style.display = "none";
                }
            }

            onMounted(() => {
                createTwitterUrl();
                createLinkedinUrl();
                createFacebookUrl();
                createShareUrl();
                removeListTitle();
            })

            const decodedContent = decodeHtml(props.content);
            return { decodedContent, searchHandler, searchInput, facebookShareUrl, twitterShareUrl, linkedinShareUrl, shareUrl };
        },
    };
</script>

<style lang="scss"></style>
